goog.provide('el8.apphome.docMgr.Sorter');

goog.require('el8.apphome.docMgr.ImageSelector');
goog.require('el8.apphome.docMgr.ImageLoader');
goog.require('el8.apphome.docMgr.renderer');
goog.require('el8.template.render.docMgr.sorter');
goog.require('el8.practicedata.base');
goog.require('el8.practicedata.uploadedImages');
goog.require('el8.practicedata.uploadedFiles');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.deleteConfirm');

el8.apphome.docMgr.Sorter = function(spec) {

    this._dialogContainer = spec.dialogContainer;
    this._container = spec.container;
    this._panel = spec.panel;
    this._isInit = false;

    this._IMAGE_WIDTH = 180;
    this._IMAGE_HEIGHT = 232;

    this._dequeueItemFn = spec.dequeueItemFn;
    this._queueItemFn = spec.queueItemFn;

    this._showFilerFn = spec.showFilerFn;
    this._resetFilerFn = spec.resetFilerFn; //used when emptying the queue
    this._syncSelectImageFn = spec.syncSelectImageFn;
    this._updateFilerImages = spec.updateFilerImages;

    this._isFilerMode = false;
};
el8.apphome.docMgr.Sorter.prototype._init = function(spec) {

    if (this._isInit) { return; }

    this._container.hide();
    this._container.append(el8.template.render.docMgr.sorter.content());
    this._list = $('#sorter-list', this._container).hide();
    this._emptyList = $('#sorter-empty-list', this._container);
    this._buttonContainer = $('#sorter-buttons', this._container).hide();

    this._imageLoader = new el8.apphome.docMgr.ImageLoader({
        initialSize: 5,
        container: this._list,
        scrollContainer: this._list,
        width: this._IMAGE_WIDTH,
        height: this._IMAGE_HEIGHT,
        imageClass: 'thumbnail',
        imageWrapSelector: '.image-item-wrap',
        buttonSelector: '.button-container',
        selector: 'li.thumbnail-item',
        rendererFn: el8.apphome.docMgr.renderer.sorter,
        itemIdFn: function(item) {
            return 'sorter-'+item.getId();
        }
    });

    var that = this;
    this._list.sortable({
        items: "li.thumbnail-item",
        axis: "y",
        forcePlaceholderSize: true,
        update: function(e, ui) {
            that._updateFilerImages();
            that._updateNumbering();
        }
    });
    this._list.disableSelection();

    this._panel.bind('el8_adjustSize', function() {
        that._adjustSize();
    });

    this._bindTriggers();
    this._adjustSize();

    var that = this;
    el8.service.pageunload.add(function() {
        var itemIds = that.getItemIds();
        for (var i=0; i<itemIds.length; i++) {
            var item = el8.practicedata.getUploadedFileOrImage(itemIds[i]);
            el8.practicedata.getEntitySet(item.getModelClass()).markUnlocked(item);
        }
    });

    this._isInit = true;
};
el8.apphome.docMgr.Sorter.prototype.show = function(spec) {
    if (!this._isInit) { this._init(); }
    this._container.show();
};
el8.apphome.docMgr.Sorter.prototype.hasItem = function(id) {
    return this._imageLoader ? this._imageLoader.hasItem(id) : false;
};
el8.apphome.docMgr.Sorter.prototype._hasOnlyFiles = function() {
    return !$('.thumbnail-item[data-type="image"]', this._container).length;
};

/**
 * Updating UI details
 */
el8.apphome.docMgr.Sorter.prototype.forceSelect = function(id) {
    if (this._imageSelector) {
        this._imageSelector.forceSelectImage(
            $('.thumbnail-item[data-id="'+id+'"]', this._container), false, false);
    }
};
el8.apphome.docMgr.Sorter.prototype._updateNumbering  = function() {
    $('.thumbnail-item', this._container).each(function(index, elt) {
        $('.image-counter', $(elt)).text(index+1);
    });
};
el8.apphome.docMgr.Sorter.prototype._updateUi = function() {
    if (this._imageLoader.hasItems()) {
        if (!this._isFilerMode) {
            this._buttonContainer.show();
            if (this._hasOnlyFiles()) {
                $('button[data-action="print"]', this._buttonContainer)
                    .prop('disabled', true);
            } else {
                $('button[data-action="print"]', this._buttonContainer)
                    .prop('disabled', false);
            }
        } else {
            this._buttonContainer.hide();
        }
        this._list.show();
        this._emptyList.hide();
        $('.sorter-header', this._container).show();
        this._updateNumbering();
    } else {
        this._list.hide();
        this._emptyList.show();
        this._buttonContainer.hide();
        $('.sorter-header', this._container).hide();
        this._resetFilerFn(); //whenever the list is emptied, the filer should be reset
    }
    this._adjustSize();
};
el8.apphome.docMgr.Sorter.prototype._adjustSize = function(spec) {
    if (this._buttonContainer.is(':visible')) {
        this._list.css('margin-bottom', this._buttonContainer.outerHeight(true) + 'px');
    } else {
        this._list.css('margin-bottom', 0);
    }
    var listMargin = this._list.outerHeight(true) - this._list.height();
    var headerHeight = $('.sorter-header', this._container).outerHeight(true);
    var tabbedNavHeight = $('.tabbed-nav', this._dialogContainer).outerHeight(true);
    var height = $('.sorter-content', this._dialogContainer).height() - tabbedNavHeight;
    $('.sorter-container', this._container).height(height)
        .css('top', tabbedNavHeight);
    this._list.height(height - listMargin - headerHeight).css('position', 'absolute');
    this._emptyList.css('top', (height - $('.sorter-empty-msg', this._container).outerHeight(true))/2);
};

/**
 * Manage "mode" -- filer or organizer
 */
el8.apphome.docMgr.Sorter.prototype.setFilerMode = function(val) {
    this._isFilerMode = !!val;
    this._updateUi();
    if (this._isFilerMode) {
        var that = this;
        if (!this._imageSelector) {
            this._imageSelector = (new el8.apphome.docMgr.ImageSelector({
                container: this._list,
                scrollContainer: this._container,
                singleSelect: true,
                syncSelectImageFn: function(id) {
                    that._syncSelectImageFn(id);
                }
            })).startListen();
        } else {
            this._imageSelector.unfreeze();
        }
        this._imageSelector.selectNthImage(0);
        this._list.scrollTo(0);
    } else {
        if (this._imageSelector) {
            this._imageSelector.freeze();
        }
    }
};


/**
 * Bind triggers
 */
el8.apphome.docMgr.Sorter.prototype._bindTriggers = function() {
    var that = this;
    this._container.on('click', 'button, a',  function(e) {
        var action = $(this).attr('data-action');
        var id = $(this).attr('data-id')*1;
        if (action === 'unselect') {
            that.dequeueItem(id);
        }
    });
    this._buttonContainer.on('click', 'button, a',  function(e) {
        var action = $(this).attr('data-action');
        switch (action) {
            case 'file':
                that._showFilerFn(that.getItemIds());
                break;
            case 'print':
                that._print();
                break;
            case 'delete':
                var itemCount = that.getItemIds().length;
                var description = (itemCount === 1) ? 'the image' : 'all ' + itemCount + ' images';
                el8.uiwidget.deleteConfirm(
                    description+' in the queue',
                    function() { that._delete(); }
                );
                break;
            case 'empty':
                that._empty();
                break;
        }
    });
};

/**
 * Managing queue/dequeue/delete of items
 */
el8.apphome.docMgr.Sorter.prototype.queueItem = function(item) {
    var that = this;
    if (!this._imageLoader.hasItem(item.getId())) {
        var that = this;
        el8.practicedata.getEntitySet(item.getModelClass()).markLocked(item, {async: false});
        that._imageLoader.addItem(item, function() {
            that._queueItemFn(item);
        });
        // Needs to run before images get loaded (async in addItem call above)
        that._updateUi();
        that._list.scrollTo('max');
    }
};
el8.apphome.docMgr.Sorter.prototype.dequeueItem = function(itemId) {
    var that = this;
    if (this._imageLoader.hasItem(itemId)) {
        var that = this;
        var item = el8.practicedata.getUploadedFileOrImage(itemId);
        // Make this call async to make sure calls return in the right order
        el8.practicedata.getEntitySet(item.getModelClass()).markUnlocked(item, {async: false});
        that._imageLoader.removeItem(itemId, function() {
            that._dequeueItemFn(itemId);
            that._updateUi();
        });
    }
};
el8.apphome.docMgr.Sorter.prototype.removeItem = function(itemId) {
    var that = this;
    if (this._imageLoader.hasItem(itemId)) {
        this._imageLoader.removeItem(itemId, function() {
            that._updateUi();
        });
    }
};
el8.apphome.docMgr.Sorter.prototype.refreshImage = function(itemId) {
    this._imageLoader.refreshImage(itemId);
};
el8.apphome.docMgr.Sorter.prototype.getItemIds = function() {
    return this._imageLoader.getItemIds();
};

/**
 * Implement batch actions for sorter
 */
el8.apphome.docMgr.Sorter.prototype.reset = function() {
    this._imageLoader.reset();
};
el8.apphome.docMgr.Sorter.prototype._empty = function() {
    var allItemIds = this.getItemIds();
    for (var i=0; i<allItemIds.length; i++) {
        this.dequeueItem(allItemIds[i]);
    }
};
el8.apphome.docMgr.Sorter.prototype._print = function() {
    var hasFile = false;
    var hasImage = false;
    var itemIds = this.getItemIds().map(function(id) {
        var item = el8.practicedata.getUploadedFileOrImage(id, true);
        if (item.is('UploadedFile')) {
            hasFile = true;
            return null;
        } else {
            hasImage = true;
            return id;
        }
    }).filter(function(a) { return a !== null; });
    if (hasFile && hasImage) {
        el8.uiwidget.confirm(
            'Only images will be printed.  To print non-image files, please download them to a computer you trust.  Continue?',
            function() { el8.practicedata.uploadedImages.printImages(itemIds); }
        );
    } else if (hasFile && !hasImage) {
        el8.uiwidget.alert(
            'To print non-image files, please download them to a computer you trust.'
        );
    } else {
        el8.practicedata.uploadedImages.printImages(itemIds);
    }
};
el8.apphome.docMgr.Sorter.prototype._delete = function() {
    var itemIds = this.getItemIds();
    for (var i=0; i<itemIds.length; i++) {
        var item = el8.practicedata.getUploadedFileOrImage(itemIds[i]);
        if (item.is('UploadedImage')) {
            el8.practicedata.uploadedImages.deleteItem(item, false, {async: false});
            el8.practicedata.uploadedImages.realtimeNotify(itemIds[i], 'DELETED');
        } else {
            el8.practicedata.uploadedFiles.deleteItem(item, false, {async: false});
            el8.practicedata.uploadedFiles.realtimeNotify(itemIds[i], 'DELETED');
        }
    }
    el8.practicedata.unfiledInboxes.load();
};
